var cannotLoadAjax = "Can not process your request";
var defaultKeyword = "Enter search term(s)";

document.addEventListener('DOMContentLoaded', function() {   
  $('#keyword').keydown(function (event) {
    if (event.keyCode == 13) {
      searchVideos(1);
    }

  });

  searchVideos(1);

});

pageClick = function (pageclickednumber) {
  searchVideos(pageclickednumber);
}

function searchVideos(page) {
  var keyword = $("#keyword").val();
  if (keyword == defaultKeyword) {
    keyword = "";
  }

  $('#ModalContentAjax').modal("show");
  var totalPage = 0;
  var requestData = 'keyword=' + keyword + '&selectedPage=' + page;
  xhr = $.ajax({
    url: "/apps/innova-api/supports/search-videos",
    cache: false,   
    type: 'post',
    data: requestData,
    error: function () {
      $('#ModalContentAjax').modal("hide");
      alert(cannotLoadAjax);
    },
    success: function (result) {     
      $('#ModalContentAjax').modal("hide"); 
      if(result.message.success){
        $('#searchVideosResult').html(result.articleResult);
        var totalPage = result.pageCount;        
        var itemsCount = result.recordCount;
        var itemsOnPage = result.pageSize;
        
        var pagination = new Pagination({
          container: $("#pagination"),
          pageClickCallback: pageClick,
          maxVisibleElements: 5
        });
        pagination.make(itemsCount, itemsOnPage, page);

        var videoPopper = new VideoPopper({
          classContainer: "viewVideo"          
        });
        videoPopper.AllfilmVideoPopper();       
        
      }else{      	 
        alert(cannotLoadAjax);
      }
    }
  });

}
